// -- Packages
import { useState } from "react";
// -- Prime React
// -- Local
import { Mode } from "../models/Mode";
import { PageState } from "./UsePageState";

export function usePanelDialog<T>() {
   /**------------------
    *      States      */
   const [displayDialog, setDisplayDialog] = useState(false);
   const [dialogValue, setDialogValue] = useState<T>({} as T);
   const [dialogValueIndex, setDialogValueIndex] = useState<number>();
   const [dialogMode, setDialogMode] = useState<Mode>(Mode.Create);

   /**------------------
    *    Functions      */
   const openDialog = (value?: T, mode?: Mode) => {
      setDialogMode(mode ?? Mode.Create);
      setDialogValue(value ?? ({} as T));
      setDisplayDialog(true);
   };

   const closeDialog = () => {
      setDisplayDialog(false);
   };

   const handleRowClicked = (index: number, value: T, mode: Mode) => {
      setDialogValueIndex(index);
      openDialog(value, mode);
   };

   const setValue = (property: keyof T, value: any, pageState?: PageState) => {
      if (pageState && !pageState?.isDirty) pageState?.markAsDirty();
      setDialogValue((prev) => ({
         ...prev,
         [property]: value,
      }));
   };

   /**------------------
    *    Result       */
   return {
      display: displayDialog,
      value: dialogValue,
      index: dialogValueIndex,
      mode: dialogMode,
      openDialog,
      closeDialog,
      handleRowClicked,
      setValue,
   } as PanelDialog<T>;
}

export interface PanelDialog<T> {
   display: boolean;
   value: T;
   index: number;
   mode: Mode;
   openDialog(value?: T, mode?: Mode): void;
   closeDialog(): void;
   handleRowClicked(index: number, value: T, mode: Mode): void;
   setValue(property: keyof T, value: any, pageState?: PageState): void;
}
